import { TIME_MASK_ZEROHOUR_ZEROMINUTES } from "../Forms/Constants/TimeConstants";

export interface SprHandlingTime {
  SupplierGsdb: string;
  PlantGsdb: string;
  HandlingTime: string;
}

export const defaultSprHandlingTime = {
  SupplierGsdb: "",
  PlantGsdb: "",
  HandlingTime: TIME_MASK_ZEROHOUR_ZEROMINUTES,
};
